if (!customElements.get("select-flavor-variant")) {
    customElements.define(
      "select-flavor-variant",
      class SelectFlavorVariant extends HTMLElement {
        constructor() {
          super();
          this.isMouseInteraction = false;
        }

        connectedCallback() {
            this.select = this.querySelector('select');
            this.container = this.querySelector('.wt-product__flavor-select-wrapper');

            this.select.addEventListener('mousedown', () => {
                this.isMouseInteraction = true;
                this.select.classList.add('mouse-focus');
            });

            this.select.addEventListener('keydown', (e) => {
                this.isMouseInteraction = false;
                this.select.classList.remove('mouse-focus');
            });

            this.select.addEventListener('focus', () => {
                if (this.isMouseInteraction) {
                    this.select.classList.add('mouse-focus');
                } else {
                    this.select.classList.remove('mouse-focus');
                }
            });

            this.select.addEventListener('blur', () => {
                this.select.classList.remove('mouse-focus');
                this.isMouseInteraction = false;
            });

            this.select.addEventListener('change', (e) => {
                e.preventDefault();

                const selectedOptions = e.target.selectedOptions[0];
                const flavorColor = selectedOptions.dataset.flavorColor;

                this.container.style.setProperty('--flavor-color', flavorColor);

                const href = selectedOptions.dataset.href;
                if(href) {
                    window.location.href = href;
                }
            });
        }

        disconnectedCallback() {
        }
      },
    );
  }
  